'use client'
import React, { useState, useEffect } from 'react';
import { Link, withRouter } from '#/renderer/router';
import { useHookstate } from '@hookstate/core';
import $ from 'jquery';
//import blukai, removido

import ModalNotification from '~/components/ui/ModalNotification';

import { validateRenewal } from '~/helpers/validate_form';
import useStores from '~/store/StoreHook';
import ModalNotificationToken from '~/components/ui/ModalNotificationToken';
import '~/sass/modules/_renewal.scss';

import '~/sass/modules/_contract.scss';
import { currencyFormat } from '~/helpers/formatter';
import moment from "moment";
// import json from './json.json'
import { validateAccountNumber, retrievePlan, retrieveStatusBalance, retrieveBillHistoryList, retrieveServiceList } from '~/store/Query/api-renewal';
import { useConfigMC } from '~/store/Query/api';
import { clearNumber, useRenewalState } from '~/store/States/renewal';
import Metatags from '~/containers/Views/Metatags';
import FormIsPostPagoComponent from '~/components/renewal/FormIsPostPagoComponent';
import FormPrepagoComponent from '~/components/renewal/FormPrepagoComponent';
import IconInfoCircle from '~/components/renewal/IconInfo';
import AlertBillExample from '~/components/renewal/AlertBillExample';
import Notification from './Notification/Notification.ui';
import SetMetatags from '~/containers/Views/SetMetatags';
import analyticsRenewal from '~/helpers/analytics-renewal';

const Modal = (props) => (
  <ModalNotification>
    <div className="text-center my-5 my-md-0 ModalRenewal">
      <nav>
        <button type="button" className="red-color btn-close" onClick={props.close}>
          <span><i className="fas fa-times-circle fa-2x" /></span>
        </button>
      </nav>
      <img src={props.modalIcon} alt="" />
      <h1>{props.modalTitle}</h1>
      <p dangerouslySetInnerHTML={{ __html: props.message }} />
      {props.modalLink?.indexOf('http') === 0 ? (
        <a
          href={props.modalLink}
          className="btn btn-lg btn-danger mb-3 botonModal1"
          target="_blank"
          rel="noopener noreferrer nofollow"
        >
          {props.modalBtnText}
        </a>
      ) : (
        <Link
          to={{ pathname: props.modalLink || '#' }}
          className="btn btn-lg btn-danger mb-3 botonModal1"
        >
          {props.modalBtnText}
        </Link>
      )}
    </div>
  </ModalNotification>
);

const Token = ({ closePopups, handleChangeToken, tokenReenviar, handleSubmitToken, error, isPostPago,
  title, description, btnText, resend, modalTokenPlaceholder, showSelect,
  retrieveList,
  currentNumberSelected,
  setCurrentNumberSelected,
  btnTextRetrieve,
  handleSubmitWithSelect }) => {
  const [inputState, setInputState] = useState('');

  const handleChangeNumber = (e) => {
    setCurrentNumberSelected(e.target.value);
  };

  const validateRetrieveList = (e) => {
    handleSubmitToken(e);
  };

  const message = (
    <div className="align-button">
      <button type="button" className="btn" data-bs-dismiss="modal" aria-label="Close" onClick={closePopups}>
        <i className="fas fa-times red-text" />
      </button>
    </div>
  );
  return (
    <ModalNotificationToken>
      {message}
      <section className="modal--content-validate-number modalToken">
        <h2>{title}</h2>
        <header>
          <p dangerouslySetInnerHTML={{ __html: description }} />
        </header>
        {
          isPostPago ? (
            <FormIsPostPagoComponent
              handleChangeToken={handleChangeToken}
              handleSubmitToken={handleSubmitToken}
              error={error}
              btnText={btnText}
              tokenReenviar={tokenReenviar}
              resend={resend}
            />
          ) : (
            <FormPrepagoComponent
              showSelect={showSelect}
              modalTokenPlaceholder={modalTokenPlaceholder}
              handleChangeToken={handleChangeToken}
              currentNumberSelected={currentNumberSelected}
              handleChangeNumber={handleChangeNumber}
              retrieveList={retrieveList}
              error={error}
              btnText={btnText}
              validateRetrieveList={validateRetrieveList}
              inputState={inputState}
              setInputState={setInputState}
              handleSubmitWithSelect={handleSubmitWithSelect}
              btnTextRetrieve={btnTextRetrieve}
            />
          )
        }
      </section>
    </ModalNotificationToken>
  );
};

const checkDatesDifference = (incomingDate) => {
  let monthDifference;
  if (incomingDate) {
    const arrayDate = incomingDate.split('/');
    const fixedDate = `${arrayDate[1]}/${arrayDate[0]}/${arrayDate[2]}`;
    const date2 = new Date(fixedDate);
    const date1 = new Date();
    const difference = (date2 - date1);
    monthDifference = difference / (1000 * 3600 * 24) / 30;
  }
  return monthDifference;
};

const Renewal2 = (props) => {
  const { data } = useConfigMC();
  const { orderStore } = useStores();
  const [message, setMessage] = useState(null);
  const [displayModal, setDisplayModal] = useState(false);
  const [displayTokenModal, setDisplayTokenModal] = useState(false);
  const [modalLink, setModalLink] = useState(null);
  const [modalBtnText, setmodalBtnText] = useState(null);
  const [modalTitle, setModalTitle] = useState(null);
  const [modalIcon, setModalIcon] = useState(null);
  const [error, setError] = useState(null);
  const [queryGenerateToken, setQueryGenerateToken] = useState(null);

  const [stateDisplayAlert, setStateDisplayAlert] = useState(-1);

  const [modalTokenBtnText, setmodalTokenBtnText] = useState(null);
  const [modalTokenTitle, setModalTokenTitle] = useState(null);
  const [modalTokenDescription, setModalTokenDescription] = useState(null);
  const [modalTokenResend, setModalTokenResend] = useState(null);
  const [modalTokenPlaceholder, setModalTokenPlaceholder] = useState(null);

  const [errorToken, setErrorToken] = useState(null);
  const [token, setToken] = useState(null);
  const [lineOfBusiness, setLineOfBusiness] = useState(null);
  const [isPostPago, setIsPostPago] = useState(null);
  const renewalState = useRenewalState();
  const state = useHookstate(renewalState.texto);
  const phoneNumber = useHookstate('');

  const [redirectTokenEmail, setRedirectTokenEmail] = useState('');

  //select with numbers of retrieve list
  const [showSelect, setShowSelect] = useState(false);
  const [retrieveList, setRetrieveList] = useState([]);
  const [currentNumberSelected, setCurrentNumberSelected] = useState('0');
  const [messageModalPayment, setMessageModalPayment] = useState('');
  const [messageAgreementExpired, setMessageAgreementExpired] = useState('');
  const [modalTokenBtnTextRetrieve, setmodalTokenBtnTextRetrieve] = useState(null);
  const [facturasPermitidas, setFactPermitidas] = useState('')
  // showbillexample
  const [showBillingExample, setShowBillingExample] = useState(false);
  const [ metaTagsConfig, setMetaTagsConfig ] = useState({ show: false, title: '', description: '', path: '' });

  useEffect(() => {
    validateRenewal();
  }, []);
  useEffect(() => {
    setMetaTagsDynamically(data);
  }, [data]);
  useEffect(() => {
    if (data && data.ok) {
      if (data.body.redirectTokenEmail) {
        setRedirectTokenEmail(data.body.redirectTokenEmail);
      }
      setFactPermitidas(data.body.numberoverdueBillsAllowed);
    }
  }, [data]);

  // useeffect to update the status when I call the modal
  useEffect(() => {
    switch (stateDisplayAlert) {
      case 0:
        // setMessage(state.renewals_modal_payment_description.value);
        setMessage(messageModalPayment);
        setModalTitle(state.renewals_modal_payment_title.value);
        setModalLink(state.renewals_modal_payment_btnLink.value);
        setmodalBtnText(state.renewals_modal_payment_btnMesssage.value);
        setModalIcon(state.renewals_modal_payment_icon.value);
        setDisplayTokenModal(false);
        break;
      case 1:
        setMessage(messageAgreementExpired);
        setModalTitle(state.renewals_modal_agreementExpired_title.value);
        setModalLink(state.renewals_modal_agreementExpired_btnLink.value);
        setmodalBtnText(state.renewals_modal_agreementExpired_btnMesssage.value);
        setModalIcon(state.renewals_modal_agreementExpired_icon.value);
        setDisplayTokenModal(false);
        break;
      case 2:
        setMessage(state.renewals_modal_nonClaro_description.value);
        setModalTitle(state.renewals_modal_nonClaro_title.value);
        setModalLink(state.renewals_modal_nonClaro_btnLink.value);
        setmodalBtnText(state.renewals_modal_nonClaro_btnMesssage.value);
        setModalIcon(state.renewals_modal_nonClaro_icon.value);
        break;
      case 4:
        setMessage(state.renewals_modal_prepago_description.value);
        setModalTitle(state.renewals_modal_prepago_title.value);
        setModalLink(state.renewals_modal_prepago_btnLink.value);
        setmodalBtnText(state.renewals_modal_prepago_btnMesssage.value);
        setModalIcon(state.renewals_modal_prepago_icon.value);
        break;
      case 5:
        setMessage(state.renewals_modal_paymentNew_description.value);
        setModalTitle(state.renewals_modal_paymentNew_title.value);
        setModalLink(state.renewals_modal_payment_redirect.value);
        setmodalBtnText(state.renwals_modal_button_continue.value);
        setModalIcon(state.renewals_modal_payment_icon.value);
        setDisplayTokenModal(false);
        break;
      case 6:
        setMessage(state.renewals_modal_payment_error_description.value);
        setModalTitle(state.renewals_modal_payment_error_title.value);
        setModalLink(state.renewals_modal_payment_redirect_error.value);
        setmodalBtnText(state.renwals_modal_button_error.value);
        setModalIcon(state.renewals_modal_payment_icon.value);
        setDisplayTokenModal(false);
        break;
      default:
        break;
    }
  }, [stateDisplayAlert, displayModal]);

   /**
   * The function sets meta tags dynamically based on a given configuration.
   * @param config - an object containing information about the response from an API call, including a
   * body property with metadata information.
   * @returns a boolean value. It returns `true` if the `config` object has a truthy `ok` property,
   * `metaTagsConfigList` exists and has a property with the key `path`, `title` and `description`
   * properties exist in `metaTagsConfig`, and a new object `newMetaTagsConfig` is successfully created
   * and passed to the `setMetaTagsConfig` function. It returns `false` otherwise.
   */
   const setMetaTagsDynamically = (config) => {

    try {

      const path = 'renewals'

      if (config?.ok === true) {

        const metaTagsConfigList = config.body['metatag_titulos_categorias']

        if (!metaTagsConfigList) {
          return false;
        }

        const metaTagsConfig = metaTagsConfigList[path] ?? null;

        if (!metaTagsConfig) {
          return;
        }

        const title = metaTagsConfig.title ?? null;
        const description = metaTagsConfig.description ?? null;

        if (!title || !description) {

          return false;

        }

        const newMetaTagsConfig = {
          show: true,
          title,
          description,
          path
        }

        setMetaTagsConfig(newMetaTagsConfig)

        return true;

      }

      return false;

    } catch (error) {
      return false;
    }

  }

  const storageData = (localNumber) => {
    if (isPostPago) {
      sessionStorage.setItem('renewals.phonePostPago', phoneNumber.value);
      sessionStorage.setItem('renewals.isPostPago', isPostPago);
    } else {
      sessionStorage.setItem('renewals.idContract', localNumber);
      sessionStorage.setItem('renewals.phoneHouse', phoneNumber.value);
      sessionStorage.setItem('renewals.phoneBill', token);
      sessionStorage.setItem('renewals.isPostPago', isPostPago);
    }
    props.history.push('/renewals-plan');
  };

  const generateToken = (lob, number) => {
    const queryGenerarToken = {
      generarToken: {
        UserProfileID: redirectTokenEmail,
        MobileNumber: number,
        LineOfBusiness: lob,
      },
    };
    //AQUI VALIDAR SI HAY QUE USAR ESTE METODO, O USAR EL TOKEN STATICO DEL MS
    if (data.body.isToken) //si es true validar el token estatico del MC, entonces no se envia al telefono
    {
      setLineOfBusiness(lob);
      setDisplayTokenModal(true);
      setDisplayModal(false);
      setQueryGenerateToken(queryGenerarToken);

    } else {
      orderStore.generarToken(queryGenerarToken).then((resultGT) => {
        if (resultGT.success) {
          const responseGT = resultGT.data.data.generarToken || resultGT.data.data.generarTokenResponse;
          if (responseGT && responseGT.AcknowledgementIndicator === 'SUCCESS') {
            setLineOfBusiness(lob);
            setDisplayTokenModal(true);
            setDisplayModal(false);
            setQueryGenerateToken(queryGenerarToken);
          } else {
            setError('Ha ocurrido un error, intente más tarde.');
          }
        } else {
          setError('Ha ocurrido un error, intente más tarde.');
        }
      });
    }


  };

  const retryValidateNumber = (validateNumber) => {
    const newQuery = { ...validateNumber, Type: 'C' };
    orderStore.validateNumber({ validateNumber: newQuery }).then((resultVN) => {
      if (resultVN.success) {
        const responseVN = resultVN.data.data.validateNumberResponse;
        if (responseVN && responseVN.AcknowledgementIndicator === 'SUCCESS'
          && responseVN.IsValidFlag && !responseVN.hasProblem) {
          if (responseVN.LineOfBusiness !== '') {
            setLineOfBusiness(responseVN.LineOfBusiness);
            switch (responseVN.LineOfBusiness) {
              case '1':
              case '10':
                setModalTokenDescription(state.renewals_modal_lineaFija_confirm_description.value);
                setModalTokenTitle(state.renewals_modal_lineaFija_confirm_title.value);
                setmodalTokenBtnText(state.renewals_modal_lineaFija_token_boton.value);
                setModalTokenPlaceholder(state.renewals_modal_lineaFija_placeholder.value);
                setmodalTokenBtnTextRetrieve(state.modal_service_confirm.value);
                setIsPostPago(false);
                setDisplayTokenModal(true);
                setDisplayModal(false);
                break;
              case '2':
                setModalTokenDescription(state.renewals_modal_confirm_description.value);
                setModalTokenTitle(state.renewals_modal_confirm_title.value);
                setmodalTokenBtnText(state.modal_token_boton.value);
                setModalTokenResend(state.modal_token_reintentar.value);
                setIsPostPago(true);
                generateToken(responseVN.LineOfBusiness, phoneNumber.value);
                break;
              case '3':
                setModalTokenDescription(state.renewals_modal_confirm_description.value);
                setModalTokenTitle(state.renewals_modal_confirm_title.value);
                setmodalTokenBtnText(state.modal_token_boton.value);
                setModalTokenResend(state.modal_token_reintentar.value);
                setIsPostPago(true);
                generateToken(responseVN.LineOfBusiness, phoneNumber.value);
                break;
              case '4':
                setDisplayModal(true);
                setStateDisplayAlert(4);
                break;
              case '8':
                sessionStorage.setItem('renewals.isPostPago', false);
                break;
              default:
                break;
            }
          } else {
            // ERROR NO ESPECIFICA LINEA DE BUSINESS
            setError('Ha ocurrido un error, intente más tarde.');
          }
        } else {
          // LINEA NO CLARO
          setStateDisplayAlert(2);
          setDisplayModal(true);
        }
      } else {
        // ERROR
        setError('Ha ocurrido un error, intente más tarde.');
      }
    });
  };

  const sendData = (e) => {
    e.preventDefault();
    setError(null);
    clearNumber();
    const $form = $("form[name='renewal']");
    if ($form.valid()) {
      phoneNumber.set($('input[name=numRequest]', $form).val().replace('-', ''));
      const queryValidateNumber = {
        validateNumber: {
          claroNumber: phoneNumber.value,
          UserProfileID: '',
          Type: phoneNumber.value.length <= 7 ? 'C' : 'N',
        },
      };

      let validateNumber;
      let genToken;
      if (process.env.NEXT_PUBLIC_ENV_NAME !== 'PROD') {
        switch (phoneNumber.value) {
          case '10101010':
            sessionStorage.setItem('renewals.mock', '1');
            validateNumber = (async () => ({
              success: true,
              data: {
                data: {
                  validateNumberResponse: {
                    AcknowledgementIndicator: 'SUCCESS',
                    IsValidFlag: true,
                    LineOfBusiness: '1',
                  },
                },
              },
            }))();
            break;
          case '20202020':
            sessionStorage.setItem('renewals.mock', '1');
            validateNumber = (async () => ({
              success: true,
              data: {
                data: {
                  validateNumberResponse: {
                    AcknowledgementIndicator: 'SUCCESS',
                    IsValidFlag: true,
                    LineOfBusiness: '2',
                  },
                },
              },
            }))();
            genToken = () => {
              setLineOfBusiness('2');
              setDisplayTokenModal(true);
              setDisplayModal(false);
            };
            break;
          default:
            validateNumber = orderStore.validateNumber(queryValidateNumber);
            genToken = generateToken;
        }
      } else {
        validateNumber = orderStore.validateNumber(queryValidateNumber);
        genToken = generateToken;
      }

      validateNumber.then((resultVN) => {
        if (resultVN.success) {
          const responseVN = resultVN.data.data.validateNumberResponse;
          if (responseVN && responseVN.AcknowledgementIndicator === 'SUCCESS'
            && responseVN.IsValidFlag && !responseVN.hasProblem) {
            if (responseVN.LineOfBusiness !== '') {
              setLineOfBusiness(responseVN.LineOfBusiness);
              switch (responseVN.LineOfBusiness) {
                case '1':
                case '10':
                  setModalTokenDescription(state.renewals_modal_lineaFija_confirm_description.value);
                  setModalTokenTitle(state.renewals_modal_lineaFija_confirm_title.value);
                  setmodalTokenBtnText(state.renewals_modal_lineaFija_token_boton.value);
                  setModalTokenPlaceholder(state.renewals_modal_lineaFija_placeholder.value);
                  setmodalTokenBtnTextRetrieve(state.modal_service_confirm.value);
                  setIsPostPago(false);
                  setDisplayTokenModal(true);
                  setDisplayModal(false);
                  break;
                case '2':
                  setModalTokenDescription(state.renewals_modal_confirm_description.value);
                  setModalTokenTitle(state.renewals_modal_confirm_title.value);
                  setmodalTokenBtnText(state.modal_token_boton.value);
                  setModalTokenResend(state.modal_token_reintentar.value);
                  setIsPostPago(true);
                  genToken(responseVN.LineOfBusiness, phoneNumber.value);
                  break;
                case '3':
                  setModalTokenDescription(state.renewals_modal_confirm_description.value);
                  setModalTokenTitle(state.renewals_modal_confirm_title.value);
                  setmodalTokenBtnText(state.modal_token_boton.value);
                  setModalTokenResend(state.modal_token_reintentar.value);
                  setIsPostPago(true);
                  genToken(responseVN.LineOfBusiness, phoneNumber.value);
                  break;
                case '4':
                  setDisplayModal(true);
                  setStateDisplayAlert(4);
                  break;
                case '8':
                  sessionStorage.setItem('renewals.isPostPago', false);
                  break;
                default:
                  break;
              }
            } else {
              // ERROR NO ESPECIFICA LINEA DE BUSINESS
              setError('Ha ocurrido un error, intente más tarde.');
            }
          } else {
            // LINEA NO CLARO
            if (phoneNumber.value.length > 7) {
              retryValidateNumber(queryValidateNumber.validateNumber);
              return;
            }
            setStateDisplayAlert(2);
            setDisplayModal(true);
          }
        } else {
          // ERROR
          setError('Ha ocurrido un error, intente más tarde.');
        }
      });
    }
  };

  const tokenReenviar = (e) => {
    e.preventDefault();
    setErrorToken('');

    if (data.body.isToken) //si es true validar el token estatico del MC, entonces no se envia al telefono
    {
      setDisplayTokenModal(true);
      setDisplayModal(false);
    } else {
      orderStore.generarToken(queryGenerateToken).then((resultGT) => {
        if (resultGT.success) {
          const responseGT = resultGT.data.data.generarToken || resultGT.data.data.generarTokenResponse;
          //console.log(responseGT);
          if (responseGT && responseGT.AcknowledgementIndicator === 'SUCCESS') {
            setDisplayTokenModal(true);
            setDisplayModal(false);
          } else {
            setError('Ha ocurrido un error, intente más tarde.');
          }
        } else {
          setError('Ha ocurrido un error, intente más tarde.');
        }
      });
    }

  };

  const closeModal = () => {
    setCurrentNumberSelected('0');
    setDisplayModal(false);
    setErrorToken('');
    setDisplayTokenModal(false);
  };

  const closePopups = () => {
    closeModal();
  };

  const handleChangeToken = (e) => {
    setToken(e.target.value);
  };

  const retryStatusBalance = async (localNumber) => {
    const response = await retrieveStatusBalance({
      retrieveStatusBalance: {
        accountId: localNumber,
        type: 'C',
      },
    });

    if (response.ok && response.body.retrieveStatusBalanceResponse.AcknowledgementIndicator === 'SUCCESS') {
      const balance = parseFloat(response.body.retrieveStatusBalanceResponse.BalanceDetail.Balance);
      if (balance <= 0) {
        storageData(localNumber);
      } else {
        const newRenewals_modal_payment_description = state.renewals_modal_payment_description.value.replace(/{amount}/g, (Math.round(balance * 100) / 100).toFixed(2)).replace(/{data}/g, localNumber);
        setMessageModalPayment(newRenewals_modal_payment_description);

        setStateDisplayAlert(0);
        setDisplayModal(true);
        setShowSelect(false);
        setRetrieveList([]);
      }
    } else {
      //error de servicio
      setErrorToken(state.renewals_modal_lineaFija_token_error.value);
    }
  };

  const onRetrieveStatusBalance = async (localNumber) => {
    const response = await retrieveStatusBalance({
      retrieveStatusBalance: {
        accountId: localNumber,
        type: localNumber.length <= 7 ? 'C' : 'N',
      },
    });

    if (response.ok && response.body.retrieveStatusBalanceResponse.AcknowledgementIndicator === 'SUCCESS') {
      const balance = parseFloat(response.body.retrieveStatusBalanceResponse.BalanceDetail.Balance);
      if (balance <= 0) {
        storageData(localNumber);
      } else {
        const newRenewals_modal_payment_description = state.renewals_modal_payment_description.value.replace(/{amount}/g, (Math.round(balance * 100) / 100).toFixed(2)).replace(/{data}/g, localNumber);
        setMessageModalPayment(newRenewals_modal_payment_description);

        setStateDisplayAlert(0);
        setDisplayModal(true);
        setShowSelect(false);
        setRetrieveList([]);
      }
    } else {
      if (localNumber.length > 7) {
        retryStatusBalance(localNumber);
        return;
      }
      //error de servicio
      setErrorToken(state.renewals_modal_lineaFija_token_error.value);
    }
  };

  const onRetrievePlan = async () => {
    const response = await retrievePlan({
      retrievePlan: {
        LineOfBusiness: lineOfBusiness,
        AccountID: phoneNumber.value,
        UserProfileID: '',
      },
    });

    if (response.ok && response.body.retrievePlanResponse.AcknowledgementIndicator === 'SUCCESS') {
      const months = checkDatesDifference(response.body.retrievePlanResponse.PlanDetail.PlanExpirationDate);
      //add new data state renewals_modal_agreementExpired_description
      // const agreementPlanName = response.body.retrievePlanResponse.PlanDetail.PlanName;
      // const newRenewals_modal_agreementExpired_description = state.renewals_modal_agreementExpired_description.value.replace(/{agreement}/g, agreementPlanName).replace(/{time}/g, Math.ceil(months));
      const newRenewals_modal_agreementExpired_description = state.renewals_modal_agreementExpired_description.value.replace(/{agreement}/g, phoneNumber.value).replace(/{time}/g, Math.ceil(months));

      if (months <= 0) {
        await onValidateSaldos();
      } else {
        setMessageAgreementExpired(newRenewals_modal_agreementExpired_description);
        setStateDisplayAlert(1);
        setDisplayModal(true);
      }
    } else {
      setStateDisplayAlert(6);
      setDisplayModal(true);
      setErrorToken('Ha ocurrido un error, intente más tarde.');
    }
  };
  const onValidateSaldos = async (numberFilter) => {
    //se hace las validaciones de las facturas
    //console.log('VALIDACIONES DE FACTURAS')
    const response = await retrieveBillHistoryList({
      retrieveBillHistoryList: {
        LineOfBusiness: lineOfBusiness,
        AccountID: phoneNumber.value,
        UserProfileID: '',
        BillsQuantity: data.body.numberBillHistory
      }
    })

    if (response.ok) {
      let conSaldo = []
      //const conSaldo = response.body.retrieveBillHistoryListResponse.BillsDetails.filter(item => item.balanceRestante !== "0" && item.telefono === numberFilter[0].virtual_number)
      if (numberFilter && numberFilter[0].virtual_number) {
        conSaldo = response.body.retrieveBillHistoryListResponse.BillsDetails.filter(item => item.balanceRestante !== "0" && item.telefono === numberFilter[0].virtual_number)

      } else {
        conSaldo = response.body.retrieveBillHistoryListResponse.BillsDetails.filter(item => item.balanceRestante !== "0")

      }

      if (conSaldo.length > 0) {
        let contador = 0
        let amount = 0
        conSaldo.map((item) => {
          if (moment(item.fechaVencimiento, "DD-MM-YYYY").diff(new Date(), 'days') < 0 && item.balanceRestante > 0) {
            contador += 1
          } else {
            contador += 0
          }
          amount += parseInt(item.balanceRestante)
        })
        if (contador >= facturasPermitidas) //ya no se deja pasar manda a pagar
        {

          //console.log('se manda a pagar')
          const newRenewals_modal_payment_description = state.renewals_modal_payment_description.value.replace(/{amount}/g, currencyFormat(Math.round(amount * 100))).replace(/{data}/g, phoneNumber.value);
          // state.renewals_modal_payment_description.set(newRenewals_modal_payment_description);
          setMessageModalPayment(newRenewals_modal_payment_description);

          setStateDisplayAlert(0);
          setDisplayModal(true);

        } else { // si el numero de facturas permitida es igual o menor, se deja pasar al formulairo o alerta Nueva ""

          //console.log('se deja pasar al formulario con alerta que debe pagar')
          if (isPostPago) {
            sessionStorage.setItem('renewals.phonePostPago', phoneNumber.value);
            sessionStorage.setItem('renewals.isPostPago', isPostPago);
          } else {
            sessionStorage.setItem('renewals.phoneHouse', phoneNumber.value);
            sessionStorage.setItem('renewals.phoneBill', token);
            sessionStorage.setItem('renewals.isPostPago', isPostPago);
          }
          setStateDisplayAlert(5);
          setDisplayModal(true);
        }
      } else {
        //no existen facturas pendientes
        storageData();
        //console.log('deja pasar al formulario directamente porqueno hay facturas con balanceRestante')

      }

    } else {
      console.error('error al obtener las facturas', response)
    }
  }


  const validateToken = async () => { //valida token
    setErrorToken('');
    const queryValidarToken = {
      validarToken: {
        UserProfileID: '',
        MobileNumber: phoneNumber.value,
        LineOfBusiness: lineOfBusiness,
        Token: token,
      },
    };
    if (data.body.isToken) {
      if (token === data.body.valueToken) {
        await onRetrievePlan()
      } else {
        setErrorToken(state.modal_token_error.value);
      }

    } else {
      orderStore.validarToken(queryValidarToken).then(async (resultVT) => {
        if (resultVT.success) {
          const responseVT = resultVT.data.data.validarTokenResponse;
          if (responseVT && responseVT.AcknowledgementIndicator === 'SUCCESS') {
            await onRetrievePlan();
          } else {
            setErrorToken(state.modal_token_error.value);
          }
        }
      });
    }

  };

  const handleSubmitWithSelect = async () => {
    await onValidateSaldos();//quitar esta linea cuando se muestre el select
  };

  const getRetrieveServiceList = async (AccountID) => {
    const response = await retrieveServiceList({
      retrieveServiceList: {
        AccountID,
        UserProfileID: '',
        LineOfBusiness: '1', //este puede cambiar
        reset: 'true',
      },
    });
    if (
      response.ok
      && response.body.retrieveServiceListResponse
      && response.body.retrieveServiceListResponse.ServiceListDetails
    ) {
      const dataServiceListDetails = response.body.retrieveServiceListResponse.ServiceListDetails;
      if (dataServiceListDetails.length > 0) {
        const regex = new RegExp('^[0-9]+$');
        const serviceListEnable = dataServiceListDetails.filter(item => regex.test(item.virtual_number));
        if (serviceListEnable.length === 1) {
          await onValidateSaldos(serviceListEnable);//quitar esta linea cuando se muestre el select
          return;
        }
        setShowSelect(true);
        setRetrieveList(serviceListEnable);
        return;
      } else {
        setError('Este número  no tiene cuentas asociadas, intente más tarde.');
      }
    }
    setError(response.retrieveServiceListResponse.AcknowledgementDescription);
  };

  const onValidateAccountNumber = async () => {
    const response = await validateAccountNumber({
      validateAccountNumber: {
        LineOfBusiness: lineOfBusiness,
        AccountID: phoneNumber.value,
        UserProfileID: '',
        Bill: token,
      },
    });

    if (!Object.prototype.hasOwnProperty.call(response.body, 'validateAccountNumberResponse')) {
      setErrorToken('No hemos podido realizar su solicitud, por favor intentalo mas tarde');
      return;
    }

    if (response.ok && response.body.validateAccountNumberResponse.IsValidFlag) {
      setErrorToken('');
      if (isPostPago) {
        await onValidateSaldos();
      } else {
        await getRetrieveServiceList(phoneNumber.value, lineOfBusiness);
      }
    } else {
      setErrorToken(state.renewals_modal_lineaFija_token_error.value);
    }
  };

  const handleSubmitToken = async (e) => {
    analyticsRenewal.confirmRenoPin();
    e.preventDefault();
    if (sessionStorage.getItem('renewals.mock')) {
      storageData();
      return;
    }
    if (isPostPago) {
      validateToken();
    } else {
      await onValidateAccountNumber();
    }
  };

  const showExampleBillId = () => {
    setShowBillingExample(!showBillingExample);
  };

  return (
    <main className="has-bootstrap">
    
      {/* <Metatags name="Renovaciones" /> */}
      {
        metaTagsConfig.show && (
          <SetMetatags
            title={metaTagsConfig.title}
            description={metaTagsConfig.description}
          />
        )
      }

      <section className="renewal">
        <div className="container">
          <div className="row text-center mt-1">
            <div className="row text-center mt-1 roboto-bold" />
            <div className="col-lg-2 col-mb-2 col-sm-1" />
            <div className="col-lg-8 col-mb-8 col-sm-10 contPrincipal">
              <form className="form-cont" name="renewal" action="" method="POST" onSubmit={sendData}>
                <img className="icoHoja" src={`${process.env.NEXT_PUBLIC_ESPOTS}/renovacion_fijos_movil/Contrato.png`} alt="" />
                <h2 className="titleForm1">{state.pantalla_principal_titulo.value}</h2>
                <span className="textForm1">{state.pantalla_principal_descripcion.value}</span>
                <div className="mb-3 input-renewal-container">
                  <input type="text" name="numRequest" placeholder={state.pantalla_principal_placeholder.value} className="form-control" required minLength={2} maxLength={11} inputMode="numeric" pattern="[0-9]*" />
                  <IconInfoCircle src={state.pantalla_principal_info_icono.value} onClick={() => showExampleBillId()} />
                </div>
                <button type="submit" onClick={() => {
                  //blukai function, removida
                }} className="btn btn-lg btn-danger mb-3 buttonForm1">{state.pantalla_principal_boton.value}</button>
                {error ? <Notification title={error} /> : null}
              </form>
            </div>
          </div>
        </div>
        {displayModal && (
          <Modal
            message={message}
            modalTitle={modalTitle}
            modalBtnText={modalBtnText}
            modalLink={modalLink}
            modalIcon={modalIcon}
            close={closeModal}
          />
        )}
        {displayTokenModal && (
          <Token
            closePopups={closePopups}
            handleChangeToken={handleChangeToken}
            tokenReenviar={tokenReenviar}
            handleSubmitToken={handleSubmitToken}
            error={errorToken}
            isPostPago={isPostPago}
            title={modalTokenTitle}
            description={modalTokenDescription}
            btnText={modalTokenBtnText}
            btnTextRetrieve={modalTokenBtnTextRetrieve}
            resend={modalTokenResend}
            modalTokenPlaceholder={modalTokenPlaceholder}
            showSelect={showSelect}
            retrieveList={retrieveList}
            currentNumberSelected={currentNumberSelected}
            setCurrentNumberSelected={setCurrentNumberSelected}
            handleSubmitWithSelect={handleSubmitWithSelect}

          />
        )}
      </section>
      {
        showBillingExample && (
          <AlertBillExample
            close={showExampleBillId}
            imageBilling={state.renewals_modal_billing_image.value}
            descriptionBilling={state.renewals_modal_billing_description.value}
          />
        )
      }
    </main>
  );
};

export default withRouter(Renewal2);
